module.exports = __webpack_public_path__ + "static/media/00031000.7e765f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/00031000.jpg
// module id = 130
// module chunks = 0